import { createSlice } from "@reduxjs/toolkit";

import { paymentRequestApi } from "../services/paymentRequests";
import type { RootState } from "../../store";
import { ResponsePage } from "../../types/GlobalTypes";
import type { PaymentRequest } from "../../types/PaymentRequestTypes";

type PaymentRequestState = {
  data: ResponsePage<PaymentRequest> | undefined;
};

const initialState: PaymentRequestState = {
  data: undefined,
};

export const PAGE_SIZE = 10;

const paymentRequestSlice = createSlice({
  name: "paymentRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      paymentRequestApi.endpoints.getPaymentRequests.matchFulfilled,
      (state, { payload }) => {
        state.data = {
          count: payload.count,
          pages: Math.ceil(payload.count / PAGE_SIZE),
          hasNext: !!payload.next,
          hasPrevious: !!payload.previous,
          results: !payload.previous
            ? payload.results
            : [...(state.data?.results || []), ...payload.results],
        };
      }
    );
  },
});

// export const {} = paymentRequestSlice.actions;

export default paymentRequestSlice.reducer;

export const selectPaymentRequests = (state: RootState) =>
  state.paymentRequests.data;
